export default __webpack_public_path__ + "static/media/dropdown.1c77f2e3.svg";